function logAndThrow(errorText: string): Error {
    console.error(errorText);
    return new Error(errorText);
}

function unwrapOrThrow<T>(
    value: T | null | undefined,
    failureMessage: string
): T {
    if (value) {
        return value;
    } else {
        console.error(failureMessage);
        throw new Error(failureMessage);
    }
}

export { logAndThrow, unwrapOrThrow };
